export class StringUtils {
  static formatUrl(url: string): string {
    if (!url) return '';
    return url.startsWith('http://') || url.startsWith('https://')
      ? url
      : `https://${url}`;
  }

  static parseSemiColonSegments(input: string): string[] {
    if (!input) return null;
    return input
      .split(';')
      .map((segment) => segment.trim())
      .filter((segment) => segment.length > 0);
  }

  static trimEffectiveDate(text: string): string {
    if (!text) return '';
    return text.replace(/\s*\(Effective Date:.*?\)$/, '');
  }
}
